import AdminLayout from '@/layouts/AdminLayout.vue'
import RentalFileService from '@/services/rental-module/RentalFileService'
import { handleResponseError } from '@/utils/toastUtils'
import legacyCrudRoutes from '@/router/legacyCrudRoutes'

// Temporary rollout compatibility. See Distributor's legacy-url-transition.md.
const redirectWithParams = (path, name) => ({
  path,
  redirect: (to) => ({ name, params: to.params, query: to.query, hash: to.hash })
})

export default function createLegacyRoutes(router) {
  // Vue Router can apply a guard redirect after a newer navigation has started.
  let navigationVersion = 0
  router.beforeEach(() => {
    navigationVersion += 1
  })

  async function redirectLegacyRentalFile(to) {
    const requestVersion = navigationVersion
    try {
      const summary = await RentalFileService.getRentalFileSummary(to.params.rentalFileId)
      if (requestVersion !== navigationVersion) return false
      if (
        typeof summary?.rental_file_boomerang_id !== 'string' ||
        !summary.rental_file_boomerang_id
      ) {
        throw new Error('Missing rental file reference')
      }
      return {
        name: 'rentalFileDetail',
        params: { rentalFileBoomerangId: summary.rental_file_boomerang_id },
        query: to.query,
        hash: to.hash
      }
    } catch (error) {
      if (requestVersion !== navigationVersion) return false
      handleResponseError(error)
      return { name: 'repairFiles' }
    }
  }

  return [
    ...legacyCrudRoutes,
    redirectWithParams(
      '/key-account-products/detail/:keyAccountProductId',
      'keyAccountProductDetail'
    ),
    redirectWithParams(
      '/key-account-products/update/:keyAccountProductId',
      'keyAccountProductUpdate'
    ),
    redirectWithParams(
      '/key-account-products/request-draft/:requestDraftId',
      'keyAccountProductRequestDraftReview'
    ),
    redirectWithParams('/rental-module', 'rentalProducts'),
    redirectWithParams('/rental-module/product-list/:repairFileBoomerangId', 'rentalProductList'),
    redirectWithParams(
      '/rental-module/product-detail/:repairFileBoomerangId/:rentalProductId',
      'rentalProductDetail'
    ),
    redirectWithParams(
      '/rental-module/rental-file-create/:repairFileBoomerangId/:rentalProductId',
      'rentalFileCreate'
    ),
    redirectWithParams('/rental-file/detail/:rentalFileBoomerangId', 'rentalFileDetail'),
    redirectWithParams('/public/rental-module/add-product-picture', 'rentalFileAddPicture'),
    {
      path: '/repair-file',
      redirect: (to) => ({ name: 'repairFiles', query: to.query, hash: to.hash })
    },
    {
      path: '/repair-file/detail/:repairFileBoomerangId',
      redirect: (to) => ({
        name: 'repairFileDetail',
        params: to.params,
        query: to.query,
        hash: to.hash
      })
    },
    {
      path: '/repair-file/finalization/:repairFileBoomerangId?',
      redirect: (to) => ({
        name: to.params.repairFileBoomerangId ? 'repairFileFinalization' : 'repairFiles',
        params: to.params.repairFileBoomerangId ? to.params : {},
        query: to.query,
        hash: to.hash
      })
    },
    {
      path: '/rental-module/rental-file-detail/:rentalFileId(\\d+)',
      name: 'legacyRentalFileDetail',
      // beforeEnter runs after the global authentication and permission guards.
      beforeEnter: redirectLegacyRentalFile,
      meta: {
        requiresAuth: true,
        layout: AdminLayout,
        hideHeader: true,
        permissions: ['ADMIN_RENTAL_READ'],
        menuSelected: 'rental'
      }
    }
  ]
}
